// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"tableContainer--x4RIE","ant-table":"ant-table--cTI2p","ant-table-thead":"ant-table-thead--6Gwu9","ant-table-tbody":"ant-table-tbody--WqqF3"};